export default __webpack_public_path__ + "static/media/aboutUs-banner.b200e880.png";